import { render, staticRenderFns } from "./ReviewItem.vue?vue&type=template&id=cfce42d0&scoped=true&lang=pug&"
import script from "./ReviewItem.vue?vue&type=script&lang=js&"
export * from "./ReviewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfce42d0",
  null
  
)

export default component.exports